import { createSelector } from 'reselect';

const getHasLoaded = createSelector(
  (state) => state.findWordsStepTwoCollections.hasLoaded,
  (hasLoaded) => hasLoaded
);
const getCurrencyData = createSelector(
  (state) => state.findWordsStepTwoCollections.data.currency,
  (currency = {}) => currency
);
const getCollectionsData = createSelector(
  (state) => state.findWordsStepTwoCollections.data.findWordsStepTwoCollections,
  (collections = []) => collections
);
const getPageCount = createSelector(
  (state) => state.findWordsStepTwoCollections.data.pageCount,
  (pageCount) => pageCount || 0
);

export default {
  getCollectionsData,
  getCurrencyData,
  getHasLoaded,
  getPageCount,
};
